import React, { useContext, useState, useEffect } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReceipt, faSyncAlt, faHourglassHalf, faCheckSquare, faWindowClose, faTimes, faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons';
import Button from 'react-bootstrap/Button';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { isNullOrUndefined } from 'util';
import { LanguageContext } from '../../containers/Language/LanguageProvider';
import { MonthlyIntakeBookContext } from '../contexts/MonthlyIntakeBookProvider';
import { LabelText } from '../../components/Language';
import { changeRequestStatuses } from '../../common/const/changeRequestHelper';
import { isEmptyObject } from '../../common/utility/utility';
import CustomOverlayTrigger from '../../hoc/CustomOverlayTrigger';
import { changeRequestTooltip } from '../../components/UI/Tooltip/Tooltip';
import { SubmitSelectionFooter } from '../../components/UI/SubmitSelectionFooter/SubmitSelectionFooter';
import { RemainingCharacters } from '../../components/UI/RemainingCharacters/RemainingCharacters';
import config from '../../common/const/config';
import './index.css';

function MonthlyIntakeBookDetail(props) {
    const languageContext = useContext(LanguageContext);
    const { handlerOnIntakeBookIconClick, handlerOnIntakeBookSubmitClick,
        handlerOnDownloadMonthlyIntakeBookClick, cancelChangeRequestHandler, setChangeRequestData } = useContext(MonthlyIntakeBookContext);
    const [monthlyIntakeBookData, setMonthlyIntakeBookData] = useState([]);
    const [approveCRList, setApproveCRList] = useState([]);
    const [expendedRowList, setExpendedRowList] = useState([]);
    const [inproCRList, setinproCRList] = useState([]);
    const [declineCRList, setDeclineCRList] = useState([]);
    const [lockedContractMonthlyList, setlockedContractMonthlyList] = useState([]);
    const [inproUnlockCRList, setinproUnlockCRList] = useState([]);

    const getContractIdByStatus = (monthlyIntakeBookDtl, status) => {
        let dtl = monthlyIntakeBookDtl && monthlyIntakeBookDtl.filter(d => d.isSubmitted && d.changeRequest &&
            d.changeRequest.changeRequestStatus === status)
            .map(row => row.contractId);
        return dtl;
    }
    const getlockedContractMonthlyList = (intakeData, status, isCrAllowed) => {
        return intakeData.filter(d => !d.isSubmitted && !d.isMonthlySubmitted &&
            d.isUnblockChangeRequestAllowed === isCrAllowed && d.unblockChangeRequest &&
            d.unblockChangeRequest.changeRequestStatus === status)
            .map(row => row.contractId);
    }

    useEffect(() => {
        if (props.monthlyIntakeBookDetails) {
            let changedData = props.monthlyIntakeBookDetails.map(d => {
                return {
                    ...d,
                    isSelectionAllowed: d.isSelectionAllowed,
                    isChecked: d.isChecked
                }
            })
            setMonthlyIntakeBookData(changedData);
            setlockedContractMonthlyList(getlockedContractMonthlyList(changedData, changeRequestStatuses.Unsubmitted.id, true));
            setinproUnlockCRList(getlockedContractMonthlyList(changedData, changeRequestStatuses.Inprogress.id, false));
            setinproCRList(getContractIdByStatus(changedData, changeRequestStatuses.Inprogress.id));
            setApproveCRList(getContractIdByStatus(changedData, changeRequestStatuses.Approve.id));
            setDeclineCRList(getContractIdByStatus(changedData, changeRequestStatuses.Decline.id));
        }
    }, [props.monthlyIntakeBookDetails]);

    const isChangeRequestRaised = (row) => {
        return row.changeRequest && row.changeRequest.changeRequestStatus > 1 ? true : false;
    }

    const lockedSubmitTooltip = (
        <Tooltip id="lockedSubmitButton">
            <LabelText tid="revenueFiguresUnsubmitted" />
        </Tooltip>
    );

    const submitTooltip = (
        <Tooltip id="submitButton">
            <LabelText tid="submit" />
        </Tooltip>
    );

    const tableRowStyle = (row, rowIndex) => {
        row.index = rowIndex;
        const style = {};
        style.lineHeight = "8vh";
        if (rowIndex % 2 === 0)
            style.backgroundColor = '#FFFFFF';
        else
            style.backgroundColor = '#EFF4F9';

        return style;
    }

    const customFormatter = (row, columnName, specialSymbol, isCurrencyFormat) => {
        return (
            <span>{specialSymbol ? row[columnName] + " " + specialSymbol : isCurrencyFormat ? (row[columnName] === 0) ? "0,00" : (row[columnName]).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, ".") : row[columnName]}</span>
        )
    }

    const getClassFromFldErrorMessage = (fieldValueErrorMessage, classname) => {
        return (!isNullOrUndefined(fieldValueErrorMessage) &&
            fieldValueErrorMessage.trim() !== "") ? classname + " highlight-field"
            : classname;
    }

    const uploadIntakeBookFormatter = (cell, row, rowIndex, extraData, isCrAllowed, isCrRaised) => {
        return (
            <OverlayTrigger placement="right"
                overlay={!row.isLocked ? (
                    <Tooltip id="helpButton">
                        {
                            !isCrAllowed ?
                                row.changeRequest && row.changeRequest.userIntakeBookFileName ?
                                    row.changeRequest.userIntakeBookFileName :
                                    row.userIntakeBookFileName ? row.userIntakeBookFileName :
                                        extraData && languageContext.labels["cashregisternotfound"]
                                : row.userIntakeBookFileName ? row.userIntakeBookFileName
                                    : extraData && languageContext.labels["cashregisternotfound"]
                        }
                    </Tooltip>) : lockedSubmitTooltip
                }>
                <div
                    key={((row.isSubmitted && !isCrAllowed) ? "Upload_Submitted_" : "Upload_") + row.index}
                    role="button" title={"Upload monthly intake book"} tabIndex="0"
                    className="file-upload-icon-container" disabled={row.isSubmitted || row.isLocked}
                    onClick={() => (!row.isSubmitted || isCrAllowed) ? row.isLocked ? undefined : handlerOnIntakeBookIconClick(row, rowIndex)
                        : row.isLocked ? undefined : handlerOnDownloadMonthlyIntakeBookClick(row.contractCode, props.intakeBookStartDate
                            , (isCrRaised || (!isCrAllowed && !row.changeRequest)) ? row.userIntakeBookFileName : row.changeRequest && row.changeRequest.userIntakeBookFileName,
                            (isCrRaised || (!isCrAllowed && !row.changeRequest)) ? row.intakeBookFileName : row.changeRequest && row.changeRequest.intakeBookFileName)}
                    onKeyDown={(e) => {
                        if ((!row.isSubmitted || isCrAllowed) && !row.isLocked && e.key === "Enter") { handlerOnIntakeBookIconClick(row, rowIndex) }
                        else if (!isCrAllowed && !row.isLocked && row.changeRequest && row.changeRequest.userIntakeBookFileName && e.key === "Enter") {
                            handlerOnDownloadMonthlyIntakeBookClick(row.contractCode, props.intakeBookStartDate
                                , (isCrRaised || (!isCrAllowed && !row.changeRequest)) ? row.userIntakeBookFileName : row.changeRequest && row.changeRequest.userIntakeBookFileName,
                                (isCrRaised || (!isCrAllowed && !row.changeRequest)) ? row.intakeBookFileName : row.changeRequest && row.changeRequest.intakeBookFileName)
                        }
                    }
                    }
                >
                    {!row.isSubmitted || isCrAllowed ? <FontAwesomeIcon
                        icon={faReceipt} className={row.isFileUploadedError ? !row.intakeBookFile ? "fa-intake-book File-notuploaded highlight-intake-book" :
                            "fa-intake-book  intake-book-uploaded highlight-intake-book" :
                            (row.isFileUploaded) ? "fa-intake-book intake-book-uploaded" :
                                "fa-intake-book File-notuploaded"} />
                        : <div className="receipt-icon"></div>}
                </div>
            </OverlayTrigger>
        )

    }

    const onSubmitHandler = (row, rowIndex, isChangeRequest) => {
        if (row.isChangeRequestAllowed && row.changeRequest &&
            (!row.changeRequest.businessPartnerRemarks || row.changeRequest.businessPartnerRemarks.trim() === "")
        ) {
            row.businessPartnerRemarks_ErrorMessage = 'mandatory';
            row.businessPartnerRemarks = "";
            setChangeRequestData(rowIndex, row.contractCode, row);
        }
        handlerOnIntakeBookSubmitClick(row, rowIndex, isChangeRequest);
    }

    const isHeaderSelectionAllow = (intakeBookData) => {
        const noOfUnsubmittedContracts = intakeBookData.some(d => !d.isSubmitted && !d.isLocked) ?
            intakeBookData.filter(d => !d.isSubmitted && !d.isLocked).length : 0;
        return noOfUnsubmittedContracts && noOfUnsubmittedContracts > 0 ? noOfUnsubmittedContracts : 0;
    }

    const handleOnContractSelect = (ev, row, extraData) => {
        row.isChecked = ev.target.checked;
        props.checkBoxSelectionHandler(row.index, row.contractCode, row)
    }

    function selectCheckboxFormatter(row) {
        return (<input id={"checkbox_" + row.index} type="checkbox" style={{ marginRight: "0.2vw" }}
            disabled={!row.isSelectionAllowed} checked={row.isSelectionAllowed && row.isChecked}
            onChange={(ev) => handleOnContractSelect(ev, row)} />)
    }


    const handleOnSelectAll = (ev) => {

        const isPartiallyChecked = props.monthlyIntakeBookDetails && props.monthlyIntakeBookDetails.length > 0 && props.monthlyIntakeBookDetails.some(d => d.isChecked);

        props.monthlyIntakeBookDetails && props.monthlyIntakeBookDetails.length > 0 && props.monthlyIntakeBookDetails.map(d => {
            if (!d.isSubmitted && !d.isLocked) {
                if (d.isSelectionAllowed) {
                    d.isChecked = !isPartiallyChecked && ev.target.checked;
                    props.checkBoxSelectionHandler(d.index, d.contractCode, d);
                }
            }
        });

        if (ev.target.checked) {
            //Write code to show popup
        }
    }

    function selectAllFormatter(column, colIndex) {
        const intakeBookData = props.monthlyIntakeBookDetails && props.monthlyIntakeBookDetails.length > 0 ? props.monthlyIntakeBookDetails : [];
        const unSubmittedCount = isHeaderSelectionAllow(intakeBookData);
        let checkedCount = 0;

        checkedCount = intakeBookData.filter(d => !d.isSubmitted && !d.isLocked &&
            d.isSelectionAllowed && d.isChecked).length;

        let isSelectAllChecked = false;
        let isPartiallyChecked = false;
        if (unSubmittedCount && checkedCount) {
            if (unSubmittedCount === checkedCount) {
                isSelectAllChecked = true;
            } else if (unSubmittedCount > checkedCount) {
                isPartiallyChecked = true;
            }
        }

        return unSubmittedCount ?
            (
                <div className="submitCheckboxHeader" >
                    <div style={{ float: "left" }}>
                        <input id={"checkboxAll"} type="checkbox"
                            ref={(input) => {
                                if (input) {
                                    input.indeterminate = isSelectAllChecked ? false : isPartiallyChecked;
                                }
                            }}
                            checked={isSelectAllChecked} onChange={(ev) => handleOnSelectAll(ev)} /></div>
                    <div style={{ textAlign: "center", paddingRight: "2.5vw" }}><span>{column.text}</span></div>
                </div>
            )
            : (<span>{column.text}</span>)
    }


    const columns = [
        {
            dataField: 'id',
            hidden: true
        },
        {
            dataField: 'contractId',
            hidden: true
        },
        {
            dataField: 'contractCode',
            text: <LabelText tid="contractcode" />,
            classes: "contractcode",
            headerClasses: "contractcode-header",
            editable: false
        },
        {
            dataField: 'totalRevenueWithTax',
            text: <LabelText tid="totalSubmittedRevenueValues" />,
            headerClasses: "total-submitted-values-header",
            editable: false,
            formatter: (cell, row, rowIndex) => customFormatter(row, "totalRevenueWithTax", undefined, true),
        },
        {
            dataField: 'totalTransmittedRevenueValue',
            text: <LabelText tid="totalTransmittedRevenueValues" />,
            headerClasses: "total-transmitted-values-header",
            editable: false,
            formatter: (cell, row, rowIndex) => customFormatter(row, "totalTransmittedRevenueValue", "%", false),
        },
        {
            dataField: 'isFileUploaded',
            text: <LabelText tid="Upload_Cash_Register" />,
            editable: false,
            headerClasses: "intake-book-header",
            formatExtraData: languageContext && languageContext.language.id,
            formatter: (cell, row, rowIndex, extraData) => uploadIntakeBookFormatter(cell, row, rowIndex, extraData, false, isChangeRequestRaised(row))
        },
        {
            dataField: 'isSubmitted',
            text: <LabelText tid="submit" />,
            editable: false,
            headerClasses: "submit-header",
            headerFormatter: selectAllFormatter,
            formatExtraData: props.monthlyIntakeBookDetails,
            formatter: (cell, row, rowIndex) => {
                if (row.isSubmitted) {
                    return (
                        <div style={{ textAlign: "center", width: "5.1vw", marginLeft: "3.7vw" }}>
                            <Button variant="secondary"
                                title="Submitted button"
                                size="sm"
                                className="submit-btn submitted-btn-bgcolor"
                                disabled
                            ><LabelText tid="submitted" /></Button>
                        </div>
                    );
                }
                else {
                    return (
                        <div style={{ width: "9vw", marginLeft: "1.7vw" }}>
                            {row.isLocked ?
                                <div style={{ float: "left" }}>
                                    <div className="fa-lock" /> </div>
                                : <div style={{ float: "left" }}>
                                    {selectCheckboxFormatter(row)}
                                </div>
                            }

                            <OverlayTrigger placement="right" overlay={!row.isLocked ? submitTooltip : lockedSubmitTooltip}>
                                <div style={{ margin: "auto", width: "5.1vw" }}>
                                    {!row.isChecked ?
                                        <Button variant="primary"
                                            title="Submit button"
                                            size="sm"
                                            className={row.isLocked ? "submit-btn Submit-btn-locked" : "submit-btn submit-btn-bgcolor"}
                                            onClick={(ev) => (!row.isLocked) ? onSubmitHandler(row, rowIndex) : undefined}
                                        ><LabelText tid="submit" /></Button>
                                        : <FontAwesomeIcon className={"fa-select-checkbox"}
                                            icon={faAngleDoubleDown} />
                                    }
                                </div>
                            </OverlayTrigger>
                        </div>
                    );
                }
            }
        },
        {
            dataField: 'createdDate',
            text: <LabelText tid="SubmittedDateTime" />,
            headerClasses: "submitted-datetime-header",
            editable: false
        }];

    const getExpendableRowInnerData = (row) => {
        return (
            <table className="MonthlyIntakeBook-inner-table">
                <thead style={{ display: "table-header-group", visibility: "collapse", padding: "0" }}>
                    <tr className="MonthlyIntakeBook-datatable-header" style={{
                        lineHeight: "8vh", color: row.index % 2 === 0 ? '#eff4f9'
                            : '#ffffff'
                    }}>
                        <th className="contractcode-header"><LabelText tid="contractcode" /></th>
                        <th className="total-submitted-values-header" ><LabelText tid="totalSubmittedRevenueValues" /></th>
                        <th className="total-transmitted-values-header" ><LabelText tid="totalTransmittedRevenueValues" /></th>
                        <th className="intake-book-header"><LabelText tid="Upload_Cash_Register" /></th>
                        <th className="submit-header"><LabelText tid="submit" /></th>
                        <th className="submitted-datetime-header"><LabelText tid="SubmittedDateTime" /></th>
                        <th className="expand-cell-header"><LabelText tid="actions" /></th>
                    </tr>
                </thead>
                <tbody style={{ display: "table-row-group", verticalAlign: "middle", borderColor: "inherit" }}>
                    {<>
                        <tr key={row.contractId} style={{
                            display: "table-row", verticalAlign: "inherit",
                            borderColor: "inherit", lineHeight: "8vh", backgroundColor: row.index % 2 !== 0 ? '#eff4f9' : '#ffffff'
                        }}
                        >
                            <td className="inner-remarks"><LabelText tid="remarks_business_partner" />(*)</td>
                            <td colSpan="2">
                                <input type="textarea" maxLength={config.maxCharLengthOfRemarks}
                                    placeholder={languageContext && languageContext.labels["allowed_chars"]}
                                    className={getClassFromFldErrorMessage(row.businessPartnerRemarks_ErrorMessage, "form-control cr-remarks")}
                                    value={row.changeRequest && row.changeRequest.businessPartnerRemarks}
                                    onChange={(e) => crRemarksChangeHandler(e, row)} />
                                {
                                    row.changeRequest.businessPartnerRemarks && row.changeRequest.businessPartnerRemarks.length > 0 ?
                                        <RemainingCharacters enteredCharsLength={row.changeRequest.businessPartnerRemarks.length} />
                                        : undefined
                                }
                            </td>
                            <td>{uploadIntakeBookFormatter(null, row, row.index, languageContext && languageContext.language.id, row.isChangeRequestAllowed)}</td>
                            <td>{renderChangeButtonIcon(row)}</td>
                            <td colSpan="2">&nbsp;</td>
                        </tr>
                    </>
                    }
                </tbody>
            </table>
        )
    }
    const getSelectedUnblockRequestData = (intakeData, contractId) => {
        if (intakeData.some(d => !d.isSubmitted && !d.isMonthlySubmitted && d.isUnblockChangeRequestAllowed
            && d.unblockChangeRequest && d.unblockChangeRequest.changeRequestStatus === changeRequestStatuses.Unsubmitted.id
            && d.contractId === contractId)) {
            return intakeData.find(d => !d.isSubmitted && !d.isMonthlySubmitted && d.isUnblockChangeRequestAllowed
                && d.unblockChangeRequest && d.unblockChangeRequest.changeRequestStatus === changeRequestStatuses.Unsubmitted.id
                && d.contractId === contractId)
        }
    }
    const getChangeRequestDataByContractId = (intakeData, contractId, columnName) => {
        if (intakeData.some(d => d.isSubmitted && d.changeRequest &&
            d.contractId === contractId)) {
            return intakeData.filter(d => d.isSubmitted && d.changeRequest &&
                d.contractId === contractId)
                .map(row => row.changeRequest[columnName]);
        }else if (intakeData.some(d => !d.isSubmitted && !d.isMonthlySubmitted && !d.isUnblockChangeRequestAllowed
            && d.unblockChangeRequest && d.unblockChangeRequest.changeRequestStatus === changeRequestStatuses.Inprogress.id
            && d.contractId === contractId)) {
            return intakeData.filter(d => !d.isSubmitted && !d.isMonthlySubmitted && !d.isUnblockChangeRequestAllowed
                && d.unblockChangeRequest && d.unblockChangeRequest.changeRequestStatus === changeRequestStatuses.Inprogress.id
                && d.contractId === contractId)
                .map(row => row.unblockChangeRequest[columnName]);
        }
    }

    const renderCrActionIcon = (expandable, rowKey, expanded) => {
        let actionIcon = <FontAwesomeIcon className={"fa-cr-action"} icon={faSyncAlt} style={{ color: "gray" }} />;
        const crNumber = getChangeRequestDataByContractId(monthlyIntakeBookData, rowKey, "changeRequestNumber");
        const unblockData = getSelectedUnblockRequestData(monthlyIntakeBookData, rowKey);
        if (expandable) {
            actionIcon = <CustomOverlayTrigger placement="left"
                tooltip={changeRequestTooltip("request_change")}>
                <FontAwesomeIcon className={"fa-cr-action"}
                    icon={faSyncAlt}
                    style={!expanded ? {
                        color: "green",
                        pointerEvents: "all"
                    }
                        : { color: "gray" }}
                    role={!expanded ? "button" : undefined}
                    tabIndex={!expanded ? "0" : "-1"}
                    onKeyDown={(e) => {
                        if (expandable && e.key === "Enter") {
                            handleOnKeyDownExpand(expanded, rowKey)
                        }
                    }
                    }
                />
            </CustomOverlayTrigger>;
        } else if (unblockData && lockedContractMonthlyList && lockedContractMonthlyList.length > 0 && lockedContractMonthlyList.some(d => d === rowKey)) {
            actionIcon = <CustomOverlayTrigger placement="left" tooltip={changeRequestTooltip("unblock_request", crNumber && crNumber[0])}>
                <div className="fa-cr-unblock" role={"button"} tabIndex={0}
                    onClick={(ev) => unblockData && props.handlerOnMonthlyUnblockRequestIconClick(unblockData, unblockData.index)}
                    onKeyDown={(ev) => {
                        if (ev.key === "Enter") {
                            unblockData && props.handlerOnMonthlyUnblockRequestIconClick(unblockData, unblockData.index)
                        }
                    }}
                />
            </CustomOverlayTrigger>;
        }
        else if ((inproCRList && inproCRList.length > 0 && inproCRList.some(d => d === rowKey)) ||
            (inproUnlockCRList && inproUnlockCRList.length > 0 && inproUnlockCRList.some(d => d === rowKey))) {
            actionIcon = <CustomOverlayTrigger placement="left"
                tooltip={changeRequestTooltip("cr_pending", crNumber && crNumber[0])}>
                <FontAwesomeIcon className={"fa-cr-inprogress"}
                    icon={faHourglassHalf} />
            </CustomOverlayTrigger>;
        }
        else if (approveCRList && approveCRList.length > 0 && approveCRList.some(d => d === rowKey)) {
            actionIcon = <CustomOverlayTrigger placement="left"
                tooltip={changeRequestTooltip("cr_approved", crNumber && crNumber[0])}>
                <FontAwesomeIcon className={"fa-cr-approve"} icon={faCheckSquare} />
            </CustomOverlayTrigger>;
        } else if (declineCRList && declineCRList.length > 0 && declineCRList.some(d => d === rowKey)) {
            actionIcon = <CustomOverlayTrigger placement="left"
                tooltip={changeRequestTooltip("cr_declined", crNumber && crNumber[0])}>
                <FontAwesomeIcon className={"fa-cr-decline"} icon={faWindowClose} />
            </CustomOverlayTrigger>;
        }

        return (
            actionIcon
        );
    }

    const handlerOnCancel = (isExpand, rowKey, row) => {
        cancelChangeRequestHandler(row.index, rowKey, row);
        setExpandRowId(isExpand, rowKey);
    }

    const renderChangeButtonIcon = (row) => {
        return (
            <div style={{ display: "flex", width: "5.1vw", marginLeft: "3.2vw", float: "left" }}>
                <CustomOverlayTrigger placement="left" tooltip={changeRequestTooltip("send_change")}>
                    <div style={{
                        display: "inline-flex",
                        margin: "0.2vw 0.4vw",
                        verticalAlign: "middle"
                    }} >
                        <div className="cr-submit-icon" role={"button"} tabIndex={"0"}
                            onClick={(ev) => onSubmitHandler(row, row.index, true)}
                            onKeyDown={(ev) => { if (ev.key === "Enter") onSubmitHandler(row, row.index, true) }}
                        />
                    </div>
                </CustomOverlayTrigger>
                <CustomOverlayTrigger placement="right"
                    tooltip={changeRequestTooltip("cancel")}>
                    <div style={{
                        display: "inline-flex",
                        margin: "0vw 0.4vw", verticalAlign: "middle"
                    }} >
                        <FontAwesomeIcon className={"fa-cr-cancel"} icon={faTimes}
                            role={"button"} tabIndex={"0"}
                            onClick={(e) => handlerOnCancel(false, row.contractId, row)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter")
                                    handlerOnCancel(false, row.contractId, row)
                            }} />
                    </div>
                </CustomOverlayTrigger>
            </div>);
    }

    const expandColumnHandler = (expanded, rowKey, expandable) => {
        return (
            <div style={{
                pointerEvents: "none"
            }}>
                {renderCrActionIcon(expandable, rowKey, expanded)}
            </div>);
    }


    const setExpandRowId = (isExpand, rowKey) => {
        if (isExpand) {
            setExpendedRowList(prevArray => [...prevArray, rowKey]);
        }
        else {
            setExpendedRowList(expendedRowList.filter((id) => id !== rowKey));
        }
    }

    const handleOnExpand = (row, isExpand) => {
        setExpandRowId(isExpand, row.contractId);
    }

    const crRemarksChangeHandler = (e, row) => {
        row.changeRequest.businessPartnerRemarks = e.target.value;
        if (e.target.value !== "") {
            row.businessPartnerRemarks_ErrorMessage = "";
        }
        setChangeRequestData(row.index, row.contractCode, row);
    }

    const handleOnKeyDownExpand = (isExpand, rowKey) => {
        if (isNullOrUndefined(expendedRowList)) {
            setExpendedRowList([]);
        }

        setExpandRowId(expendedRowList.length === 0, rowKey);
    }

    const expandRow = {
        renderer: (row) => getExpendableRowInnerData(row),
        expandHeaderColumnRenderer: ({ isAnyExpands }) => {
            return <span><LabelText tid={"actions"} /></span>;
        },
        expandColumnPosition: 'right',
        expandColumnRenderer: ({ expanded, rowKey, expandable }) => expandColumnHandler(expanded, rowKey, expandable),
        expanded: expendedRowList,
        onExpand: handleOnExpand,
        showExpandColumn: true,
        expandByColumnOnly: true,
        onlyOneExpanding: true,
        nonExpandable: monthlyIntakeBookData && monthlyIntakeBookData.length > 0 && monthlyIntakeBookData.reduce((arr, item, index) => {
            if (!item.isSubmitted || (item.isSubmitted && !item.isChangeRequestAllowed && (!item.changeRequest || isEmptyObject(item.changeRequest)))
                || (item.isSubmitted && !item.isChangeRequestAllowed &&
                    ((item.changeRequest && item.changeRequest.changeRequestStatus === changeRequestStatuses.Inprogress.id)
                        || isChangeRequestRaised(item)))) { arr.push(item.contractId) }
            return arr;
        }
            , []),
    }

    const isSubmitSelectionAllowed = monthlyIntakeBookData && monthlyIntakeBookData.length > 0
        && monthlyIntakeBookData.some(d => !d.isSubmitted && !d.isLocked && d.isSelectionAllowed && d.isChecked);

    return (
        <div>
            <Container>
                <Row>
                    <BootstrapTable
                        keyField='contractId'
                        data={monthlyIntakeBookData && monthlyIntakeBookData.length > 0 ? monthlyIntakeBookData : []}
                        columns={columns}
                        bordered
                        noDataIndication={props.monthlyIntakeBookDetails && props.monthlyIntakeBookDetails.length > 0 ? <LabelText tid="data_loading" />
                            : <LabelText tid="Noactivecontract" />}
                        rowStyle={tableRowStyle}
                        classes={"monthly-intakebook-details-datatable scroller"}
                        headerClasses={"monthly-intakebook-details-datatable-header"}
                        expandRow={expandRow}
                        cellEdit={
                            cellEditFactory({
                                mode: 'click',
                                blurToSave: true
                            })}
                    />
                </Row>
                <Row>
                    <SubmitSelectionFooter isSubmitSelectionAllowed={isSubmitSelectionAllowed}
                        showSelectionFooter={isHeaderSelectionAllow(monthlyIntakeBookData && monthlyIntakeBookData.length > 0 ? monthlyIntakeBookData : [])}
                        selectedData={monthlyIntakeBookData.filter(
                            d => !d.isSubmitted && !d.isLocked && d.isSelectionAllowed && d.isChecked
                        )}
                        selectedDate={props.intakeBookStartDate}
                        submitSelectedHandler={props.submitSelectedIntakeHandler}
                        selectedCount={isSubmitSelectionAllowed ?
                            monthlyIntakeBookData.filter(d => !d.isSubmitted && !d.isLocked && d.isSelectionAllowed && d.isChecked).length
                            : 0
                        }
                    />
                </Row>
            </Container>
        </div>
    );
}

export default MonthlyIntakeBookDetail;